<template>
  <div class="moji-zadaci section">
    <div class="section-title zadaci-title">
      {{ event_type }}<span class="zadaci-amount">{{ event_data.length }}</span>
    </div>
    <div class="add-zadatak add-button add-plus" style="display: none">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="12"
        viewBox="0 0 12 12"
      >
        <g>
          <g>
            <path
              fill="#0acab1"
              d="M11.465 4.767a.73.73 0 0 0-.537-.22h-3.28V1.265a.73.73 0 0 0-.221-.537.73.73 0 0 0-.536-.22H5.377a.73.73 0 0 0-.537.22.73.73 0 0 0-.22.537v3.28H1.339a.73.73 0 0 0-.536.221.729.729 0 0 0-.221.536v1.515c0 .21.073.389.22.536a.73.73 0 0 0 .537.22h3.28v3.281c0 .21.074.39.221.537a.73.73 0 0 0 .537.22H6.89a.73.73 0 0 0 .536-.22.73.73 0 0 0 .22-.537v-3.28h3.281a.73.73 0 0 0 .537-.221.73.73 0 0 0 .22-.536V5.303a.73.73 0 0 0-.22-.536z"
            />
          </g>
        </g>
      </svg>
    </div>
    <div v-if="event_data.length == 0">Nema dostupnih događaja</div>
    <div :key="refreshKey">
      <div
        v-for="(event, key) in event_data.slice(0, 4)"
        :key="key"
        class="zadatak"
        :id="'zadatak-'+event.event_type.uid+'-'+event.uid"
      >
        <div :class="['zadatak-datum', checkDate(event.start_date_time) ? 'proslo' : '']"><span :class="event.start_date_time == null ? 'is-na':'' ">{{ event.start_date_time != null ? getDate(event.start_date_time) : 'N/A' }}</span></div>
        <div class="zadatak-naziv-autor" @click="openPopup(event)">
          <div v-if="event.title.length >= 27" class="zadatak-naziv">
            {{ event.title.slice(0, 27) }}...
          </div>
          <div v-else class="zadatak-naziv">{{ event.title }}</div>
          <!-- <div class="zadatak-autor">Marko M.</div> -->
          <div v-if="event.start_date_time != null" class="vrijeme-event">
            <svg  v-if="event.event_type.uid == 1 || event.event_type.uid == 4" xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none" style="margin-top:-0.4rem">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3595 2.42254L14.3604 3.07846C16.7707 3.26737 18.3629 4.90979 18.3655 7.42853L18.375 14.8011C18.3784 17.5472 16.6532 19.2369 13.8878 19.2412L7.1329 19.25C4.38479 19.2535 2.63796 17.5236 2.63451 14.7696L2.62501 7.48363C2.62155 4.94828 4.15759 3.31022 6.5679 3.08896L6.56704 2.43303C6.56617 2.04823 6.85126 1.75875 7.23138 1.75875C7.61151 1.75787 7.8966 2.04648 7.89746 2.43129L7.89832 3.04348L13.03 3.03648L13.0291 2.42429C13.0282 2.03948 13.3133 1.75088 13.6934 1.75C14.0649 1.74913 14.3587 2.03773 14.3595 2.42254ZM3.95629 7.75387L17.0359 7.73638V7.43028C16.9988 5.54997 16.0554 4.56347 14.3621 4.41654L14.363 5.08995C14.363 5.46602 14.0701 5.76424 13.6986 5.76424C13.3185 5.76512 13.0326 5.46776 13.0326 5.0917L13.0317 4.38331L7.90005 4.3903L7.90091 5.09782C7.90091 5.47476 7.61669 5.77211 7.23657 5.77211C6.85645 5.77299 6.57049 5.47651 6.57049 5.09957L6.56963 4.42616C4.885 4.59495 3.95284 5.58496 3.95543 7.48188L3.95629 7.75387ZM13.3349 11.7288V11.7384C13.3436 12.1407 13.6718 12.4459 14.0701 12.4371C14.4589 12.4275 14.769 12.0943 14.7604 11.692C14.7422 11.3072 14.4304 10.9932 14.0425 10.9941C13.6451 11.0029 13.3341 11.3265 13.3349 11.7288ZM14.0485 15.6555C13.6511 15.6468 13.3306 15.3153 13.3297 14.913C13.3211 14.5107 13.6399 14.1775 14.0373 14.1679H14.0459C14.452 14.1679 14.7811 14.4994 14.7811 14.9104C14.782 15.3215 14.4537 15.6547 14.0485 15.6555ZM9.7756 11.7427C9.79288 12.145 10.122 12.459 10.5194 12.4415C10.9082 12.4232 11.2183 12.0908 11.2011 11.6885C11.1916 11.295 10.8719 10.9889 10.4831 10.9897C10.0857 11.0072 9.77474 11.3404 9.7756 11.7427ZM10.5229 15.6162C10.1255 15.6337 9.7972 15.3197 9.77906 14.9174C9.77906 14.5151 10.0892 14.1828 10.4866 14.1644C10.8754 14.1635 11.1959 14.4696 11.2045 14.8623C11.2227 15.2655 10.9116 15.5978 10.5229 15.6162ZM6.21629 11.7734C6.23357 12.1757 6.56272 12.4905 6.96012 12.4721C7.34888 12.4546 7.65902 12.1214 7.64088 11.7191C7.63224 11.3256 7.31259 11.0195 6.92297 11.0204C6.52557 11.0379 6.21542 11.3711 6.21629 11.7734ZM6.96357 15.6206C6.56617 15.6389 6.23788 15.3241 6.21974 14.9218C6.21888 14.5195 6.52989 14.1863 6.92729 14.1688C7.31605 14.1679 7.63656 14.474 7.6452 14.8676C7.66334 15.2699 7.35319 15.6031 6.96357 15.6206Z" fill="#55556A"/>
            </svg>
            <svg v-else
              xmlns="http://www.w3.org/2000/svg"
              width="15"
              height="16"
              viewBox="0 0 15 16"
            >
              <g>
                <g>
                  <path
                    fill="#606076"
                    d="M15 7.765A7.476 7.476 0 1 1 7.524.289 7.484 7.484 0 0 1 15 7.765zM8.058 3.493a.534.534 0 0 0-1.068 0v3.738H3.252a.534.534 0 0 0 0 1.068h4.272a.534.534 0 0 0 .534-.534z"
                  />
                </g>
              </g>
            </svg>
            <div v-if="event.event_type.uid == 1 || event.event_type.uid == 4">
              {{ getDate(event.start_date_time) }}
            </div>
            <div v-else>
              <div v-if="event.start_date_time != event.end_date_time">
                {{ getSatiEvent(event.start_date_time) }} -
                {{ getSatiEvent(event.end_date_time) }}
              </div>
              <div v-else>{{ getSatiEvent(event.start_date_time) }}</div>
            </div>
          </div>
        </div>
        <div class="task-checkbox-wrapper">
          <div class="task-checkbox-container">
            <!-- spinner koji se aktivira na klik i traje dok se ne izvrsi update -->
              <svg class="update-event-spin" :id="'spin-'+event.event_type.uid+'-'+event.uid" viewBox="0 0 50 50" style="display:none">
                <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="8"></circle>
              </svg>

            <div :id="'chk-'+event.event_type.uid+'-'+event.uid" class="custom-checkbox" @click="handleCheckClick(event)">
              <div class="check"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="section-square kreiraj-spis">
      <div>Dodaj zadatak</div>
    </div> -->
    <div class="zadaci-row">
      <div v-if="event_type == 'Moji zadaci' || event_type == 'Moji rokovi' || event_type == 'Moji sastanci'" class="zadaci-svi pogledaj-sve dodaj-item" @click="openAddEvent(event_type == 'Moji zadaci' ? 1 : event_type == 'Moji rokovi' ? 4 : 3)">Dodaj {{event_type == 'Moji zadaci' ? 'zadatak' : event_type == 'Moji rokovi' ? 'rok' : 'sastanak'}}</div>
      <router-link to='/kalendar' v-if="event_data != 0 && event_data.length > 4" class="zadaci-svi pogledaj-sve pogledaj-item">pogledaj sve</router-link>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import gsap from 'gsap';
import ms_calendar from "@/apiCallers/calendarSharepoint";
import $ from 'jquery';
export default {
  props: ["event_type", "event_data"],
  data(){
    return{
      updating:false,
      refreshKey:0,
    }
  },
  methods: {
    async handleCheckClick(event){
      //starting spinner
      this.$emit("dontRefresh", event)
      gsap.to(
        "#chk-"+event.event_type.uid+'-'+event.uid,
        0,
        { display: "none", borderColor:"#0acab1" }
      );
      gsap.to(
        "#spin-"+event.event_type.uid+'-'+event.uid,
        0.3,
        { display: "block" }
      );
        

      setTimeout(async () => {
        await ms_calendar.editEventBucketStatus(event.uid, event.personal_event != undefined ?'personal' : 'case_event', 0).then((resp)=>{
          //makni spinner
          gsap.to(
            "#spin-"+event.event_type.uid+'-'+event.uid,
            0,
            { display: "none" }
          );
          //postavi checked
          gsap.to(
              "#chk-"+event.event_type.uid+'-'+event.uid,
              0.2,
              { display:"flex", border: "3px solid #c8f8f2" }
            );
          gsap.to(
              "#chk-"+event.event_type.uid+'-'+event.uid,
              0.4,
              { backgroundColor: "#0acab1" }
            );
          //makni redak nakon pol sekunde
            setTimeout(() => {
              //makni redak
              let tl = gsap.timeline();
              tl.to(
                "#zadatak-"+event.event_type.uid+'-'+event.uid,
                0.7,
                { opacity:0, x:50 }
              );
              tl.to(
                "#zadatak-"+event.event_type.uid+'-'+event.uid,
                0,
                { display: "none" }
              );
            }, 800);
            //na kraju makni s popisa
            setTimeout(() => {
              this.$emit("taskIzvrsen", event)
              this.refreshKey++;
            }, 1600);
        }).catch((err)=>{});
      }, 300);
    },
    getSatiEvent(fullDateTime) {
      return moment(fullDateTime).format("LT");
    },
    getDate(fullDateTime) {
      return moment(fullDateTime).format("DD.MM.YYYY");
    },
    openPopup(event) {
      this.$store.state.event_details.popup_open = true;
      this.$store.state.event_details.chosen_event = event;
    },
    openAddEvent(type){
      this.$store.state.chosen_type = type; 
      this.$router.push("/kalendar/novi-osobni-dogadaj");
    },
    checkDate(date){
        let today = moment()
        let date_check = moment(date)
        return moment(today).isAfter(date_check)
    }
  },
  mounted() {},
};
</script>